import React from "react";

import { styled } from "styled-components";

import { ChipGroup } from "shared/ui/filters";

function CategoryRequire2({
  dateButtonClicked,
  setDateButtonClicked,
  setPage,
  category,
}) {
  const handleChange = (index) => {
    const updatedButtons = Array.from(dateButtonClicked).fill(false);
    updatedButtons[index] = true;
    setDateButtonClicked(updatedButtons);
    setPage(1);
  };

  const options = category.map((label, index) => ({ label, value: index }));
  const activeIndex = dateButtonClicked.findIndex(Boolean);

  return (
    <Panel>
      <ChipGroup
        options={options}
        value={activeIndex}
        onChange={handleChange}
        allowDeselect={false}
      />
    </Panel>
  );
}

export default CategoryRequire2;

const Panel = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  padding: 15px 20px;
  background-color: white;
  border-radius: 4px;
`;
